import React, { useState } from 'react'
import { ellips, repair } from '../../assets'
import { Button, Input } from '../../components/Generic'

const Repair = () => {
  const [active, setActive] = useState('Phone')
  return (
    <>
    <div className='flex flex-col justify-center items-center'>
    <img className="absolute top-[30%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
    <img className='w-[55px] h-[68px] mt-[100px]' src={repair} alt="" />
        <div className='text-gray-darkGray font-sans text-[20px]'>Repair password</div>
        <div className='text-gray-lightlyGray font-sans text-[16px]'>Send code to your {active==='Phone' ? 'number' : 'email' }</div>
      <div className='flex items-center bg-blue-ligghtBlue p-[5px] mt-[30px]  rounded-[50px] gap-[14px] box-border'>
        <div onClick={()=>setActive('Phone')} className={`flex items-center justify-center px-[46px] w-[153px] h-[40px] py-[12px] rounded-[50px] text-gray-lightGray font-[Poppins] cursor-pointer ${active==='Phone' ? 'bg-gray-inputGray':'bg-gray-inputGray shadow-tabShadow opacity-70'}`}>Phone</div>
        <div onClick={()=>setActive('Email')} className={`flex items-center justify-center px-[46px] w-[153px] h-[40px] py-[12px] rounded-[50px] text-gray-lightGray font-[Poppins] cursor-pointer ${active==='Email' ? 'bg-gray-inputGray':'bg-gray-inputGray shadow-tabShadow opacity-70'}`}>Email</div>
      </div>
    <div className='mt-[46px] '>
    {active==='Phone' ?
    <div className='w-[288px] md:w-full'>
      <Input style={`h-[60px] px-[15px] md:w-[388px] mb-[157px]`} corner={true} placeholder={'+998 | Enter Number'}/>
      <Button link={'/repairnum'} value={'Next'}/>
    </div>
    :
    <div className='w-[288px] md:w-full'>
      <Input style={`h-[60px] px-[15px] md:w-[388px] mb-[157px]`} corner={true} placeholder={'Enter email'}/>
      <Button link={'/repairemail'} value={'Next'}/>
    </div>
     }
        
    </div>
    </div>
    </>
  )
}

export default Repair